import { TransportType } from "~/generated/graphql";
import { PAGE_TRACKING } from "~/tools/getTrackingCategoryName";
import type { ItineraryData } from "../../../contract";

export enum PRICE_SELECTION_TYPE {
  PRIME = "prime_",
  NON_PRIME = "",
}

export const getPriceSelectionLabel = (
  wasSelectedPrimePrice: boolean,
): string =>
  wasSelectedPrimePrice
    ? PRICE_SELECTION_TYPE.PRIME
    : PRICE_SELECTION_TYPE.NON_PRIME;

export const getLabelY = (hasTrain: boolean, hasFlight: boolean): string =>
  !hasTrain ? "flight" : hasFlight ? "xfaring" : "train";

export const getLabelS = (
  isMultiDestination: boolean,
  isRoundTrip: boolean,
): string => (isMultiDestination ? "MD" : isRoundTrip ? "RT" : "OW");

export const CATEGORY = PAGE_TRACKING.FLIGHTS_SUMMARY;
export const ACTION = "continue_button";
export const LABEL = {
  trackOnContinueButtonClick: ({
    wasSelectedPrimePrice,
    itineraryData,
  }): string => {
    const { transportTypes, isMultiDestination, isRoundTrip } = itineraryData;
    const hasTrain = transportTypes.includes(TransportType.Train);
    const hasFlight = transportTypes.includes(TransportType.Plane);
    return `${getPriceSelectionLabel(wasSelectedPrimePrice)}sum_cont_p:${getLabelY(
      hasTrain,
      hasFlight,
    )}_ppos:1_rpos:1_label:0_tab:_type:${getLabelS(
      isMultiDestination,
      isRoundTrip,
    )}_vp:0`;
  },
};
export const tracking = {
  CATEGORY,
  ACTION,
  LABEL,
};

interface trackOnContinueButtonClickProps {
  wasSelectedPrimePrice: boolean;
  itineraryData: ItineraryData;
}
export interface TrackingFunctions {
  trackOnContinueButtonClick: ({
    wasSelectedPrimePrice,
    itineraryData,
  }: trackOnContinueButtonClickProps) => void;
}

export const getTrackingFunctions = ({ track }): TrackingFunctions => ({
  trackOnContinueButtonClick: ({
    wasSelectedPrimePrice,
    itineraryData,
  }): void =>
    track(
      LABEL.trackOnContinueButtonClick({
        wasSelectedPrimePrice,
        itineraryData,
      }),
    ),
});
